import { operatorApiFetch } from './apiService';

export const rateCardService = {
  // 取得版本列表
  fetchList: async (merchantId) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards`, {
      method: 'GET'
    });
    return response.json();
  },

  // 取得當前生效版本
  getCurrent: async (merchantId) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards/current`, {
      method: 'GET'
    });
    return response.json();
  },

  // 取得單一版本
  get: async (merchantId, id) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards/${id}`, {
      method: 'GET'
    });
    return response.json();
  },

  // 建立新版本
  create: async (merchantId, data) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards`, {
      method: 'POST',
      body: JSON.stringify({ rate_card: data })
    });
    return response.json();
  },

  // 更新版本
  update: async (merchantId, id, data) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ rate_card: data })
    });
    return response.json();
  },

  // 試算：用 rate_card 參數對貨主當前實際庫存試算當日倉租
  preview: async (merchantId, data) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards/preview`, {
      method: 'POST',
      body: JSON.stringify({ rate_card: data })
    });
    return response.json();
  },

  // 刪除版本
  delete: async (merchantId, id) => {
    const response = await operatorApiFetch(`merchants/${merchantId}/rate_cards/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  }
};

export default rateCardService;
